var exports = {
  "k": "container__ekbFxT",
  "q": "placeholder__d9Wh3D",
};

module.exports = exports;
